import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const useButtonLogic = ({ color }) => {
  const {
    colors: { lightOrDark },
  } = useContext(ThemeContext);
  const colorShade = lightOrDark(color);

  return { colorShade };
};

export default useButtonLogic;
